<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import CatParts from './CatParts'
import PartsType from './PartsType'
import Brand from './Brand'
import McButtonBack from '@/components/McButtonBack'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    CatParts,
    PartsType,
    Brand,
    McButtonBack,
  },
  computed: {
    title() {
      return this.$t('setting.list.maintenance.parts')
    },

    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting/',
        },
        {
          text: this.$t('setting.homePage.pemeliharaanKendaraan'),
          to: '/setting/maintenance/',
        },
        {
          text: this.$t('setting.list.maintenance.parts'),
          active: true,
        },
      ]
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="mc-page-three" />

    <p class="mb-4 teal-300">
      {{ $t('setting.list.maintenance.descriptionParts') }}
    </p>

    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <McButtonBack href="/setting/maintenance/" />
      </div>
    </div>

    <form>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted">
          <CatParts ref="CatParts" status="CatParts" />
          <PartsType ref="PartsType" status="PartsType" />
          <Brand ref="Brand" status="Brand" />
        </b-tabs>
      </b-card>
    </form>
  </Layout>
</template>
